module.exports = __webpack_public_path__ + "img/banner_emi.8d1a101f.jpg";